import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const CollectionsSelector = ({ collections = [], value = [], onChange }) => {
  const { t } = useTranslation()

  return (
    <div>
      <ComboBox
        menuItems={collections?.map(c => ({ label: c.name, value: c.id }))}
        value={value || []}
        multiple
        fullWidth
        label={t('Colección')}
        handleChange={e => onChange(e.target.value)}
        placeholder={t('Todas')}
      />
    </div>
  )
}

export default CollectionsSelector
